import { render, staticRenderFns } from "./CompBookStep3.vue?vue&type=template&id=c6daf4ee&scoped=true"
import script from "./CompBookStep3.vue?vue&type=script&setup=true&lang=js"
export * from "./CompBookStep3.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6daf4ee",
  null
  
)

export default component.exports